import { BLUE_300, BLUE_500, BLUE_700 } from '../colors';
var floatingButtonConfig = {
  theme: 'light',
  size: 'sm',
  controlState: 'none',
  position: 'bottom-center',
  config: {
    size: {
      lg: {
        height: 48
      },
      sm: {
        height: 40
      }
    },
    controlState: {
      none: {
        buttonColor: BLUE_500
      },
      hover: {
        buttonColor: BLUE_300
      },
      pressed: {
        buttonColor: BLUE_700
      }
    }
  }
};
export default {
  light: floatingButtonConfig,
  dark: floatingButtonConfig,
  white: floatingButtonConfig
};